module.exports = __webpack_public_path__ + "static/img/bac.89029c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/projectImg/bac.jpg
// module id = Xk7Y
// module chunks = 1